import { render, staticRenderFns } from "./stop2.vue?vue&type=template&id=68179312&scoped=true"
import script from "./stop2.vue?vue&type=script&lang=js"
export * from "./stop2.vue?vue&type=script&lang=js"
import style0 from "./stop2.vue?vue&type=style&index=0&id=68179312&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68179312",
  null
  
)

export default component.exports